// extracted by mini-css-extract-plugin
module.exports = {"lia-feedback":"AddFeaturedPlacesModal_lia-feedback__wqdCb","lia-description":"AddFeaturedPlacesModal_lia-description__0Z3bq"};